<script setup>
import { ref, computed, nextTick } from "vue"
import { onMounted } from 'vue'
import { $bus } from '@/common/events.js'
import { guid } from '@/common/helper.js'

const uniqueId = ref(guid());

const props = defineProps({
  title: {
    type: String,
    default: null
  },
  enabled: {
    type: Boolean,
    default: true
  },
  visible: {
    type: Boolean,
    default: true
  },
  side: {
    type: String,
    default: "right"
  },
});

const emit = defineEmits(['close']);

const isDrawerVisible = computed(() => {
  return props.visible;
});

function hideDrawer() {
  emit("close");
}
</script>

<template>
  <div :style="$attrs.style">
    <Teleport to="body">
      <div drawer-backdrop="" class="bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30 transition-opacity" :class="{ 'opacity-0': !isDrawerVisible, 'opacity-100': isDrawerVisible }" v-if="isDrawerVisible" @mousedown="hideDrawer"></div>
    </Teleport>

    <!-- Drawer component -->
    <div class="fixed top-0 right-0 z-40 h-screen p-4 overflow-y-auto transition-transform bg-white sm:w-1/2 md:w-1/2 lg:w-1/3 dark:bg-gray-800" :class="{ 'translate-x-full': !isDrawerVisible }" tabindex="-1" aria-labelledby="drawer-label">
      <h5 class="inline-flex items-center mb-4 text-base font-semibold text-gray-700 dark:text-gray-400">{{ props.title }}</h5>
      <button type="button" aria-controls="drawer-example" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white" @click="hideDrawer">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
        <span class="sr-only">Close menu</span>
      </button>

      <slot />

    </div>
  </div>
</template>

<style scoped>
</style>
